// src/ScheduleGame.js

import React, { useState } from 'react';
import { db } from './firebase';
import { collection, addDoc } from 'firebase/firestore';
import useDocumentMeta from './useDocumentMeta';
import './ScheduleGame.css';

const ScheduleGame = () => {
  // ─────────────────────────────────────────────────────────
  // SEO Metadata for Schedule a Game page
  useDocumentMeta({
    title: 'Schedule a Game — Glass City Gladiators',
    description: 'Request a matchup against the Glass City Gladiators by filling out our Schedule a Game form. We’ll be in touch to set up your next contest!',
    canonical: 'https://gcghockey.com/schedule-game',
    ogImage:   'https://gcghockey.com/assets/og-schedule-game.png',
    ogType:    'website'
  });
  // ─────────────────────────────────────────────────────────

  const [formData, setFormData] = useState({
    teamName: '',
    rinkLocation: '',
    contactName: '',
    phone: '',
    email: '',
    birthYear: '',
    mhr: '',
    willingToTravel: '',
    gameDates: []
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDateChange = (e) => {
    const selectedDate = e.target.value;
    if (selectedDate && !formData.gameDates.includes(selectedDate)) {
      setFormData({ 
        ...formData, 
        gameDates: [...formData.gameDates, selectedDate] 
      });
    }
  };

  const handleRemoveDate = (dateToRemove) => {
    setFormData({
      ...formData,
      gameDates: formData.gameDates.filter(date => date !== dateToRemove)
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'scheduledGames'), {
        ...formData,
        submittedAt: new Date().toISOString(),
      });
      alert('Form submitted successfully!');
      setFormData({
        teamName: '',
        rinkLocation: '',
        contactName: '',
        phone: '',
        email: '',
        birthYear: '',
        mhr: '',
        willingToTravel: '',
        gameDates: []
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div className="schedule-game-page">
      <h1 className="schedule-heading">Schedule a Game</h1>
      <p className="schedule-subheading">
        Fill out the form below to request a matchup against the Gladiators.
      </p>

      <form className="schedule-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Team Name</label>
          <input
            type="text"
            name="teamName"
            value={formData.teamName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Home Rink Location</label>
          <input
            type="text"
            name="rinkLocation"
            value={formData.rinkLocation}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Contact Name</label>
          <input
            type="text"
            name="contactName"
            value={formData.contactName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Phone</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Birth Year of Team</label>
          <input
            type="number"
            name="birthYear"
            value={formData.birthYear}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Expected MHR</label>
          <input
            type="text"
            name="mhr"
            value={formData.mhr}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Willing to Travel?</label>
          <select
            name="willingToTravel"
            value={formData.willingToTravel}
            onChange={handleChange}
            required
          >
            <option value="">-- Select --</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>

        <div className="form-group">
          <label>Select Potential Game Dates</label>
          <input type="date" onChange={handleDateChange} />
          <ul className="date-list">
            {formData.gameDates.map((date, idx) => (
              <li key={idx}>
                {date}
                <button
                  type="button"
                  onClick={() => handleRemoveDate(date)}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>

        <button type="submit" className="submit-button">
          Submit
        </button>
      </form>
    </div>
  );
};

export default ScheduleGame;
